<template lang="pug">
	.element-information(v-if="showed" :style="{opacity: alpha, width: `${Layout.subAsideSize}px`, height: `calc(100% - ${Layout.headerHeight + Layout.subHeaderHeight}px)`, top: `${Layout.headerHeight + Layout.subHeaderHeight}px`, right: `${right}px`}")
		.header-info-container(v-if="element")
			.default-info-header
				.icon.fa(:class=`{
						'fa-globe': element.type === 'global',
						'fa-newspaper-o': element.type === 'root-container',
						'fa-folder': element.type === 'container',
						'fa-picture-o': element.type === 'image',
						'fa-font': element.type === 'text',
						'fa-pencil': element.type === 'graphics'
					}`)
				.name(v-if="element.type === 'global'")
					span Global
				.name(v-else-if="element.type === 'root-container'")
					span Scene:&nbsp;
					span {{screen.title}}
				.name(v-else) {{element.codename}}
				.close-button(v-on:click="close")
					.fa.fa-angle-double-right
		.editor-types
			.editor-type.properties(:class="{selected: Layout.editorElementTab === 'properties'}" @click="Layout.setEditorElementTab('properties')")
				.title Property
				i.fa.fa-cubes
			.editor-type.effects(:class="{selected: Layout.editorElementTab === 'effects'}" @click="Layout.setEditorElementTab('effects')")
				.title Animation
				i.fa.fa-film
			.editor-type.events(:class="{selected: Layout.editorElementTab === 'events'}" @click="Layout.setEditorElementTab('events')")
				.title Event
				i.fa.fa-bell-o
		EditorElementInfoProperties(v-if="Layout.editorElementTab === 'properties'")
		EditorElementInfoEffects(v-else-if="Layout.editorElementTab === 'effects'")
		EditorElementInfoEvents(v-else-if="Layout.editorElementTab === 'events'")
</template>

<script>

	import Screen 							from './../../mixins/screen'

	import { Layout } 						from './../../services/Layout'

	import EditorElementInfoProperties		from './../Editor/EditorElementInfoProperties'
	import EditorElementInfoEffects			from './../Editor/EditorElementInfoEffects'
	import EditorElementInfoEvents			from './../Editor/EditorElementInfoEvents'

	export default {
		name: 'EditorElementInfo',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched",
				"Settings Tab Changed",
				"Aside State Changed"
			],
			events: {
				"Sub Aside State Changed": function() {

					this.checkOpen();

				},
				"Element Tab Changed": function() {

					this.update();

				}
			}
		},
		components: {
			EditorElementInfoProperties,
			EditorElementInfoEffects,
			EditorElementInfoEvents
		},
		data() {

			this.screen = null;
			this.element = null;

			this.Layout = Layout;

			return {
				showed: false,
				alpha: 0,
				right: 0
			};

		},
		mounted() {

		},
		methods: {
			checkOpen() {

				if (Layout.subAsideOpened) {

					if (!this.showed) {

						this.show();

						this.alpha = 0;
						this.right = 0;

						setTimeout(() => {
							this.alpha = 1;
							this.right = Layout.asideSize;
						}, 1);

					}

				}

				else {

					if (this.showed) {

						this.hide();

					}

				}

			},
			collectData() {

				this.screen = ScreenService.SelectedScreen;
				this.element = Elements.SelectedElement;

			},
			close() {

				Elements.selectElement(null);

			}
		}

	}
</script>

<style lang="sass">

	.element-information
		position: absolute
		z-index: 100
		right: 0
		top: 0
		border-left: 1px solid #23282c
		background-color: #343b41
		transition: opacity 0.25s, right 0.25s
		color: #f3f4f5
		overflow-y: auto
		overflow-x: hidden
		
		&::-webkit-scrollbar
			width: 4px
			scrollbar-gutter: stable
		&::-webkit-scrollbar-thumb
			background-color: #3f454b
			border-radius: 10px
			width: 20px
			background-clip: padding-box
		&::-webkit-scrollbar-track
			background-color: #ADB6BF66

		.header-info-container
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			height: 46px
			padding: 5px
			border-bottom: 1px solid #23282c
			cursor: default

			.default-info-header
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				align-items: center
				justify-content: left
				width: 100%

				.icon
					padding: 5px
					opacity: 0.8

				.name
					padding: 5px

					span:first-child
						color: var(--gray)

				.close-button
					padding: 5px
					margin-left: auto
					cursor: pointer

					&:hover
						color: #20a8d8
						opacity: 1

			.tutorial-text-header
				font-size: 12px
				color: var(--yellow)

			.tutorial-text-description
				color: var(--yellow)

		.editor-types
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			justify-content: space-between
			align-items: center
			border-bottom: 1px solid #23282c

			.editor-type
				border: 1px solid transparent
				background: rgba(255, 255, 255, 0.05) no-repeat
				padding-top: 4px
				padding-bottom: 4px
				padding-right: 0.5rem
				padding-left: 0.5rem
				color: #73818f
				cursor: pointer
				font-size: 13px
				text-transform: uppercase
				display: flex
				flex-direction: row-reverse
				justify-content: center
				align-items: center
				width: 100%
				user-select: none

				&:first-child
					margin-right: -1px

				&:last-child
					margin-left: -1px

				.title
					padding-left: 7px

				i.fa
					margin-top: 2px

			.editor-type:hover
				//border: 1px solid #fff
				//background: rgba(255, 255, 255, 0.1) no-repeat

				.title, i.fa
					color: #c1d3e4

			.editor-type.selected
				border: 1px solid #2ac0f3
				background: rgba(255, 255, 255, 0.1) no-repeat

				.title, i.fa
					color: #2ac0f3

</style>
